<template>
  <div class="header-container" :class="{ lifetime }">
    <div
      class="background-container position-absolute"
      :class="[showShadowStyle, chooseBackgroundOnExp]"
      :style="shadowColorStyle"
    ></div>
    <b-container class="h-100 d-flex flex-column align-items-center justify-content-center">
      <b-row class="mt-auto">
        <b-col>
          <h1 class="exp-font heading">
            {{ $t(`${plansPage}.${planExperience()}.tags.${planExperience()}Plans`) }}
          </h1>
        </b-col>
      </b-row>
      <b-row class="mb-auto">
        <b-col class="d-flex align-items-center flex-column">
          <h2 class="title text-center">
            {{ $t(`${plansPage}.${planExperience()}.tags.headerTitle`) }}
          </h2>
          <h3 class="subtitle text-center">
            {{ $t(`${plansPage}.${planExperience()}.tags.headerSubtitle`) }}
          </h3>
        </b-col>
      </b-row>
      <b-row v-if="showSwitch">
        <b-col class="d-flex text-center">
          <nuxt-link
            class="p-4 exp-tab merch"
            :class="{ active: getExperience == 'merch' }"
            :to="$trailingSlash(localePath('merch-plans'))"
            @click.native="
              $ga.event('All Plans', 'Click Plans Tab', $trailingSlash(localePath('merch-plans')))
            "
          >
            {{ $t(`${plansPage}.merch.tags.headerTabMerch`) }}
          </nuxt-link>
          <nuxt-link
            class="p-4 exp-tab textdesign"
            :class="{ active: getExperience == 'design' }"
            :to="$trailingSlash(localePath('design-plans'))"
            @click.native="
              $ga.event('All Plans', 'Click Plans Tab', $trailingSlash(localePath('design-plans')))
            "
          >
            {{ $t(`${plansPage}.merch.tags.headerTabDesign`) }}
          </nuxt-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    showSwitch: {
      type: Boolean,
      required: false,
      default: true
    },
    showShadow: {
      type: Boolean,
      required: false,
      default: false
    },
    shadowColor: {
      type: String,
      required: false,
      default: 'white'
    },
    lifetime: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters('plans', ['openPlan']),
    ...mapGetters('experience', ['getExperience']),
    showShadowStyle() {
      return this.showShadow ? 'bg-shadow' : '';
    },
    chooseBackgroundOnExp() {
      return `${this.getExperience}-bg-img`;
    },
    shadowColorStyle() {
      return `color: ${this.shadowColor};`;
    },
    plansPage() {
      return this.lifetime ? 'lifetimePlans' : 'plans';
    }
  },
  methods: {
    planExperience() {
      const experienceType = this.openPlan?.experienceType;
      return this.$urlNameChecker('purchase') && experienceType
        ? experienceType
        : this.getExperience;
    }
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  height: 310px;
  .heading {
    font-size: 20px;
    text-transform: capitalize;
  }
  .title {
    font-size: 29px;
    font-weight: 500;
    margin-bottom: 16px;
  }
  .subtitle {
    font-size: 16px;
    font-weight: 400;
    color: $strongGray;
    width: 64%;
    @include lg {
      width: 72%;
    }
    @include md {
      width: 100%;
    }
  }
  &.lifetime {
    .title {
      font-size: 29px;
      font-weight: 500;
      color: #545454 !important;
    }
    .subtitle {
      font-size: 17px;
      text-transform: capitalize;
      color: #545454 !important;
      font-weight: 400;
      margin-top: 25px;
    }
  }
  .exp-tab {
    width: 250px;
    @include sm {
      width: 150px;
    }
    background-color: $lightestGray;
    color: gray;
    z-index: 0;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    &.active {
      background-color: white;
      box-shadow: 0px 0px 31px #00000017;
      z-index: 1;
    }
  }
  .background-container {
    background-size: cover;
    background-position: center;
    background-color: white;
    width: 100%;
    left: 0px;
    top: -70px;
    height: 380px;
    &.bg-shadow {
      box-shadow: inset 0px -50px 20px -20px;
    }
  }
  .merch-bg-img {
    background-image: url('https://cdn.vexels.com/img/header-design-plans-merch.jpg');
  }
  .design-bg-img {
    background-image: url('https://cdn.vexels.com/img/header-design-plans.jpg');
  }
}
</style>
